import script from "./MenusView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenusView.vue?vue&type=script&setup=true&lang=js"

import "./MenusView.vue?vue&type=style&index=0&id=1f45e6a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f45e6a0"]])

export default __exports__